import {
  Flex,
  Text,
  useColorModeValue,
  SimpleGrid,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  IconButton,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import IconBox from "components/icons/IconBox";
import {
  formatCurrencyFloor,
  convertDateToFormattedString,
} from "config/functions";
import { useState } from "react";
import {
  MdAttribution,
  MdCancel,
  MdCreditCard,
  MdOutlineDoNotDisturbOnTotalSilence,
  MdOutlineLocationOn,
  MdOutlinePriceCheck,
  MdPublishedWithChanges,
  MdQrCode,
} from "react-icons/md";
import MapCard from "views/admin/atendimento/profile/components/MapCard";

export default function Transaction(props: { extrato: any }) {
  const { extrato, ...rest } = props;

  const textColor = useColorModeValue("secondaryGray.900", "brand.200");
  const iconBoxBg = useColorModeValue("secondaryGray.300", "brand.200");
  const textRedBg = useColorModeValue("red.500", "brand.200");
  const textVerdeBg = useColorModeValue("green.500", "brand.200");
  const textBg = useColorModeValue("brand", "brand.200");
  const [pedidoModal, setPedidoModal] = useState(false);

  const onChangeModalOpen = () => {
    const fotoElementoUsuario = document.getElementById("fotoElementoUsuario");
    const fotoElementoUsuario2 = document.getElementById(
      "fotoElementoUsuario2"
    );

    if (fotoElementoUsuario) fotoElementoUsuario.style.display = "none";
    if (fotoElementoUsuario2) fotoElementoUsuario2.style.display = "none";

    setPedidoModal(true);
  };

  const onChangeModalClose = () => {
    const fotoElementoUsuario = document.getElementById("fotoElementoUsuario");
    const fotoElementoUsuario2 = document.getElementById(
      "fotoElementoUsuario2"
    );

    if (fotoElementoUsuario) fotoElementoUsuario.style.display = "block";
    if (fotoElementoUsuario2) fotoElementoUsuario2.style.display = "block";

    setPedidoModal(false);
  };

  const formatDateTime = (dateTimeString: string) => {
    const date = new Date(dateTimeString);

    const padZero = (num: number): string => num.toString().padStart(2, "0");

    const day = padZero(date.getDate());
    const month = padZero(date.getMonth() + 1); // meses começam em 0
    const year = date.getFullYear();

    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());

    return `${day}/${month}/${year} às ${hours}:${minutes}:${seconds}`;
  };

  const statusIcon = (status: any) => {
    switch (status) {
      case 1: // debito
        return (
          <Icon
            as={MdOutlineDoNotDisturbOnTotalSilence}
            color={textRedBg}
            w="20px"
            h="18px"
          />
        );
      case 2: // credito
        return <Icon as={MdQrCode} color={textRedBg} w="20px" h="18px" />;
      case 3: // cancelamento
        return <Icon as={MdCancel} color={textRedBg} w="20px" h="18px" />;
      case 4: // Integração
        return (
          <Icon as={MdPublishedWithChanges} color={textBg} w="20px" h="18px" />
        );
      case 21: // Gratuidades
        return <Icon as={MdAttribution} color={textBg} w="20px" h="18px" />;
      default:
        return (
          <Icon
            as={MdOutlinePriceCheck}
            color={textVerdeBg}
            w="20px"
            h="18px"
          />
        );
    }
  };

  const statusTipoMovimento = (status: any) => {
    switch (status) {
      case 1:
      case 40:
      case 55:
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Débito
          </Text>
        );
      case 2:
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Crédito em conta
          </Text>
        );
      case 3:
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Cancelamento
          </Text>
        );
      case 4:
      case 41:
      case 22:
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Integração
          </Text>
        );
      case 5:
      case 42:
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Transferência
          </Text>
        );
      case 21:
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Gratuidade
          </Text>
        );
      case 25:
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Gratuidade Acompanhante
          </Text>
        );
      default:
        return null;
    }
  };

  const statusTipoMidia = (status: any) => {
    switch (status) {
      case 1:
        return (
          <Text
            color={textColor}
            fontSize="sm"
            me="6px"
            fontWeight="700"
            ml="5px"
          >
            CARTÃO - {extrato?.tipo || extrato?.tipoMovimento}
          </Text>
        );
      case 2:
        return (
          <Text
            color={textColor}
            fontSize="sm"
            me="6px"
            fontWeight="700"
            ml="5px"
          >
            QR CODE - {extrato?.tipo || extrato?.tipoMovimento}
          </Text>
        );
      case 3:
        return (
          <Text
            color={textColor}
            fontSize="sm"
            me="6px"
            fontWeight="700"
            ml="5px"
          >
            NFC
          </Text>
        );

      default:
        return (
          <Text
            color={textColor}
            fontSize="sm"
            me="6px"
            fontWeight="700"
            ml="5px"
          >
            {extrato?.tipo || extrato?.tipoMovimento}
          </Text>
        );
    }
  };

  const tipoValor = (status: any, valor: any) => {
    switch (status) {
      case 4:
      case 2:
        return (
          <Text
            ms="auto"
            color={textVerdeBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            {formatCurrencyFloor(valor)}
          </Text>
        );
      case 1:
        return (
          <Text
            ms="auto"
            color={textRedBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            {formatCurrencyFloor(valor)}
          </Text>
        );
      default:
        return null;
    }
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      w="100%"
      mt={{ base: "10px", md: "20px" }} // Margem ajustada para celular
      direction={{ base: "column", md: "row" }} // Direção da coluna em telas pequenas
      {...rest}
    >
      <IconBox
        h="42px"
        w="42px"
        bg={iconBoxBg}
        me={{ base: "0", md: "20px" }} // Margin-end zero no celular
        mb={{ base: "10px", md: "15px" }} // Margem inferior ajustada
        icon={statusIcon(extrato?.idTipoMidia)}
      />
      <Flex
        direction="column"
        align="start"
        me="auto"
        mb="15px"
        justifyItems="center"
        w="100%"
      >
        <Text
          color={textColor}
          fontSize={{ base: "sm", md: "md" }}
          me="6px"
          fontWeight="700"
        >
          <Flex direction="row" align="start" me="auto" mt="5px">
            {statusTipoMovimento(extrato?.tipoMovimento)}
            {statusTipoMidia(extrato?.idTipoMidia)}
          </Flex>
          {extrato?.nomeClienteDestino && (
            <Text fontSize="sm" fontWeight="700">
              {extrato?.tipoUtilizacao === 1 ? "para " : "de "}
              {extrato?.nomeClienteDestino}
            </Text>
          )}
        </Text>
        {extrato?.numeroLinha && (
          <Text fontSize="small" fontWeight="500" ml={"5px"}>
            <b>Linha:</b> {extrato?.numeroLinha} -{" "}
            {extrato?.descricaoLinha || extrato?.nomeLinha}
          </Text>
        )}
        {extrato?.numeroSerieValidador && (
          <Text fontSize="small" fontWeight="500" ml={"5px"}>
            <b>Validador:</b> {extrato?.numeroSerieValidador}
          </Text>
        )}
        <Text color={textBg} fontSize="small" fontWeight="500" ml={"5px"}>
          {convertDateToFormattedString(extrato?.timestamp)}
        </Text>
      </Flex>
      <Flex
        direction="row"
        align={{ base: "center", md: "flex-end" }} // Alinha ao centro no celular
        justify="flex-end"
        mb="15px"
      >
        <SimpleGrid alignSelf="flex-end">
          {tipoValor(extrato?.tipoUtilizacao, extrato?.valorTransacao || 0.0)}
          {extrato?.latitude !== null && (
            <IconButton
              aria-label="Transfer"
              borderRadius="50%"
              w="0px"
              h="0px"
              mt="10px"
              ml={{ base: "0", md: "90px" }} // Margin-left ajustada para celular
              icon={
                <Icon
                  as={MdOutlineLocationOn}
                  width="30px"
                  height="20px"
                  color={textColor}
                  onClick={onChangeModalOpen}
                />
              }
            />
          )}
        </SimpleGrid>
      </Flex>
      <Modal isOpen={pedidoModal} onClose={onChangeModalClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Informações de embarque:</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Card justifyContent="center" flexDirection="row">
              <MapCard
                latitude={extrato?.latitude}
                longitude={extrato?.longitude}
                valor={tipoValor(
                  extrato?.tipoUtilizacao,
                  extrato?.valorTransacao || 0.0
                )}
                data={formatDateTime(extrato?.timestamp)}
                nomeLinha={extrato?.nomeLinha || extrato?.descricaoLinha}
                numeroLinha={extrato?.numeroLinha}
                numeroValidador={extrato?.numeroSerieValidador}
              />
            </Card>
          </ModalBody>
          <ModalFooter alignSelf="center"></ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}
